import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import Loader from "../Loader/Loader";

const PrivateRoute = () => {
  const navigate = useNavigate();
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    if (!token) {
      const timer = setTimeout(() => {
        const newToken = localStorage.getItem("token");
        handleIframeRequest();
        setToken(newToken);
        setChecking(false);
      }, 10000);

      return () => clearTimeout(timer);
    } else {
      setChecking(false);
    }
  }, [token]);

  const handleIframeRequest = () => {
    const params = new URLSearchParams(window.location.search);

    const isDealer = params.get("isDealer");
    const parArn = params.get("parArn");

    if (window.self !== window.top) {
      console.log("Request came from iframe!");

      if (isDealer) localStorage.setItem("isDealer", isDealer);
      if (parArn) localStorage.setItem("incoming_parArn", parArn);
      localStorage.setItem("iframe_redirect", "piplineAndService");

      <Navigate to="/" replace />;
    } else {
      navigate("/");
    }
  };

  if (checking) {
    return (
      <div>
        <Loader />
      </div>
    );
  }

  if (!token) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default PrivateRoute;
